import { render, staticRenderFns } from "./SiteRecaptcha.vue?vue&type=template&id=fca1245c"
import script from "./SiteRecaptcha.vue?vue&type=script&lang=js"
export * from "./SiteRecaptcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports